import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "pb-3 pt-3 text-left",
  textContent: 'Hvor mange skader har du haft på dine forsikringer de seneste 2 år?'
}, null, -1)
const _hoisted_2 = {
  class: "text-left mt-n3 mb-3",
  key: "skaderErr"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg antal skader'
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: "Rki" }
const _hoisted_6 = {
  class: "pb-3 text-left",
  key: "RkiLabel"
}
const _hoisted_7 = {
  class: "text-left mb-3",
  key: "rkiErr"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg ja eller nej'
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: "childrenCpr" }
const _hoisted_11 = { key: "otherCpr" }
const _hoisted_12 = { class: "text-left font--small mb-2" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "text-left font--small mb-2" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = ["textContent"]
const _hoisted_17 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SegmentedControlComponent = _resolveComponent("SegmentedControlComponent")!
  const _component_PopoverComponent = _resolveComponent("PopoverComponent")!
  const _component_RadioComponent = _resolveComponent("RadioComponent")!
  const _component_inputFieldComponent = _resolveComponent("inputFieldComponent")!
  const _component_AddressSearchComponent = _resolveComponent("AddressSearchComponent")!
  const _component_checkboxComponent = _resolveComponent("checkboxComponent")!
  const _component_ButtonTapComponent = _resolveComponent("ButtonTapComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_TransitionGroup, { name: "slide-simple" }, {
      default: _withCtx(() => [
        _createVNode(_component_SegmentedControlComponent, {
          key: "skader",
          class: "pb-3",
          id: "skader",
          options: _ctx.skaderOptions,
          labels: _ctx.skaderLabels,
          preSelected: _ctx.basketModel.contact_information.skader,
          controlsPerRow: 4,
          onSegmentedComponent: _ctx.handleSelection
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["options", "labels", "preSelected", "onSegmentedComponent"]),
        (!_ctx.basketModel.pristineStep.get(_ctx.card.name) && !_ctx.basketModel.contact_information.skader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_ctx.rkiHeader), 1),
            (_ctx.rkiPopover)
              ? (_openBlock(), _createBlock(_component_PopoverComponent, {
                  key: 0,
                  type: "icon",
                  class: "page-component__popover text-left",
                  buttonClass: "popover__icon popover__icon__questionmark",
                  innerData: _ctx.rkiPopover
                }, null, 8, ["innerData"]))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jaNejArray, (item, inx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass([inx + 1 === _ctx.jaNejArray.length ? 'pb-3' : 'pb-2']),
              key: 'rki' + inx
            }, [
              _createVNode(_component_RadioComponent, {
                name: "rki",
                id: 'rki' + item.value,
                inputValue: item.value,
                preSelect: _ctx.basketModel.contact_information.rki,
                trackingLabel: _ctx.rkiHeader,
                onRadioComponent: _ctx.handleRkiClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.displayValue), 1)
                ]),
                _: 2
              }, 1032, ["id", "inputValue", "preSelect", "trackingLabel", "onRadioComponent"])
            ], 2))
          }), 128)),
          (!_ctx.basketModel.pristineStep.get(_ctx.card.name) && _ctx.basketModel.contact_information.rki === undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, _ctx.skaderOk]
        ]),
        _withDirectives(_createVNode(_component_inputFieldComponent, {
          id: "frmNameA",
          name: "name",
          key: "name",
          placeholder: "F.eks. Peter Petersen",
          label: "Navn",
          validateOnLoad: !_ctx.basketModel.pristineStep.get(_ctx.card.name),
          innerData: _ctx.basketModel.contact_information,
          required: true,
          onInputFieldComponent: _ctx.setSubHeader,
          visibleError: !_ctx.basketModel.pristineStep.get(_ctx.card.name),
          class: "text-left pb-3"
        }, null, 8, ["validateOnLoad", "innerData", "onInputFieldComponent", "visibleError"]), [
          [_vShow, 
					_ctx.basketModel.contact_information.rki === 'nej' &&
					!_ctx.basketModel.contact_information.customerNo &&
					_ctx.skaderOk
				]
        ]),
        _withDirectives(_createVNode(_component_inputFieldComponent, {
          id: "frmPhoneNumA",
          name: "phone",
          key: "phone",
          type: "tel",
          innerData: _ctx.basketModel.contact_information,
          placeholder: " F.eks. 12 34 56 78",
          labelPopover: _ctx.basketCms.phoneNoPopOver,
          label: "Telefonnummer",
          validateOnLoad: !_ctx.basketModel.pristineStep.get(_ctx.card.name),
          required: true,
          visibleError: !_ctx.basketModel.pristineStep.get(_ctx.card.name),
          class: "text-left pb-3"
        }, null, 8, ["innerData", "labelPopover", "validateOnLoad", "visibleError"]), [
          [_vShow, _ctx.basketModel.contact_information.rki === 'nej' && _ctx.skaderOk]
        ]),
        _withDirectives(_createVNode(_component_inputFieldComponent, {
          id: "frmEmailC",
          name: "email",
          key: "email",
          type: "email",
          placeholder: "F.eks. peter@mailtest.dk",
          label: "E-mail",
          validateOnLoad: !_ctx.basketModel.pristineStep.get(_ctx.card.name),
          required: true,
          innerData: _ctx.basketModel.contact_information,
          visibleError: !_ctx.basketModel.pristineStep.get(_ctx.card.name),
          class: "text-left pb-3"
        }, null, 8, ["validateOnLoad", "innerData", "visibleError"]), [
          [_vShow, _ctx.basketModel.contact_information.rki === 'nej' && _ctx.showEmail && _ctx.skaderOk]
        ]),
        _withDirectives(_createVNode(_component_AddressSearchComponent, {
          class: "text-left pb-4",
          id: "address",
          key: "address",
          elementId: "address",
          isOnlyZipSearch: false,
          label: "Adresse",
          placeholder: "F.eks Gadenavn 29, 2.tv...",
          defaultValue: _ctx.basketModel.personInfo.address,
          isValid: _ctx.basketModel.personInfo.address !== undefined,
          visibleError: !_ctx.basketModel.pristineStep.get(_ctx.card.name),
          onAddressSearch: _ctx.addressSearch
        }, null, 8, ["defaultValue", "isValid", "visibleError", "onAddressSearch"]), [
          [_vShow, _ctx.showAddress && _ctx.emailFilled && _ctx.skaderOk]
        ]),
        _withDirectives(_createVNode(_component_inputFieldComponent, {
          key: "cpr",
          id: "cpr",
          name: "cpr",
          innerData: _ctx.basketModel.contact_information,
          placeholder: "10 cifre",
          label: "CPR-nummer",
          validateOnLoad: !_ctx.basketModel.pristineStep.get(_ctx.card.name),
          required: true,
          visibleError: !_ctx.basketModel.pristineStep.get(_ctx.card.name),
          class: "text-left pb-3"
        }, null, 8, ["innerData", "validateOnLoad", "visibleError"]), [
          [_vShow, 
					_ctx.basketModel.contact_information.rki === 'nej' &&
					_ctx.emailFilled &&
					!_ctx.basketModel.contact_information.customerNo &&
					_ctx.addressFilled &&
					_ctx.skaderOk
				]
        ]),
        (
					_ctx.modelChildren &&
					_ctx.basketModel.contact_information.rki === 'nej' &&
					_ctx.emailFilled &&
					_ctx.skaderOk &&
					(_ctx.basketModel.contact_information.customerNo ||
						_ctx.fieldValidator.isValidCpr(_ctx.basketModel.contact_information.cpr)) &&
					_ctx.addressFilled
				)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelChildren.familyInfo.personCountId + 1, (inx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'ch' + inx
                }, [
                  (_openBlock(), _createBlock(_component_inputFieldComponent, {
                    key: 'cc' + (inx - 1),
                    id: 'cpr' + (inx - 1),
                    name: 'cpr' + (inx - 1),
                    innerData: _ctx.modelChildren.familyInfo,
                    placeholder: "10 cifre",
                    label: 'CPR-nummer for ' + _ctx.modelChildren.familyInfo['name' + (inx - 1)],
                    validateOnLoad: !_ctx.basketModel.pristineStep.get(_ctx.card.name),
                    required: true,
                    fieldValidatorType: "cprUnderEighteen",
                    visibleError: !_ctx.basketModel.pristineStep.get(_ctx.card.name),
                    class: "text-left pb-3"
                  }, null, 8, ["id", "name", "innerData", "label", "validateOnLoad", "visibleError"]))
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (
					_ctx.hasAdultCpr &&
					_ctx.basketModel.contact_information.rki === 'nej' &&
					_ctx.emailFilled &&
					(_ctx.basketModel.contact_information.customerNo ||
						_ctx.fieldValidator.isValidCpr(_ctx.basketModel.contact_information.cpr)) &&
					_ctx.addressFilled &&
					_ctx.skaderOk
				)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelAdultAccident, (elem, inx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'ach' + inx
                }, [
                  (elem.personInfo.otherCustomerAge !== undefined)
                    ? (_openBlock(), _createBlock(_component_inputFieldComponent, {
                        key: 'otherCpr' + inx,
                        id: 'otherCpr' + inx,
                        name: "otherCpr",
                        innerData: elem.personInfo,
                        placeholder: "10 cifre",
                        label: 'CPR-nummer for ' + elem.personInfo.otherName,
                        validateOnLoad: !_ctx.basketModel.pristineStep.get(_ctx.card.name),
                        required: true,
                        fieldValidatorType: "cpr",
                        visibleError: !_ctx.basketModel.pristineStep.get(_ctx.card.name),
                        class: "text-left pb-3"
                      }, null, 8, ["id", "innerData", "label", "validateOnLoad", "visibleError"]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_checkboxComponent, {
          key: "acceptConsentCpr",
          id: "acceptConsentCpr",
          name: "acceptConsentCpr",
          preSelect: _ctx.basketModel.contact_information.acceptConsentCpr,
          inputValue: 'samtykke cpr',
          class: "pb-3",
          validationErrorText: "Du mangler at give samtykke",
          visibleError: !_ctx.basketModel.pristineStep.get(_ctx.card.name),
          onCheckboxComponent: _ctx.checkboxEvent
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_12, [
              _createElementVNode("span", {
                innerHTML: _ctx.basketCms.consentCprText
              }, null, 8, _hoisted_13)
            ])
          ]),
          _: 1
        }, 8, ["preSelect", "visibleError", "onCheckboxComponent"]), [
          [_vShow, _ctx.emailFilled && _ctx.basketModel.contact_information.rki === 'nej' && _ctx.addressFilled && _ctx.skaderOk]
        ]),
        _withDirectives(_createVNode(_component_checkboxComponent, {
          key: "acceptOtherCompanyConsent",
          id: "acceptOtherCompanyConsent",
          name: "acceptOtherCompanyConsent",
          preSelect: _ctx.basketModel.contact_information.acceptOtherCompanyConsent,
          inputValue: 'samtykke',
          class: "pb-3",
          validationErrorText: "Du mangler at give samtykke",
          visibleError: !_ctx.basketModel.pristineStep.get(_ctx.card.name),
          onCheckboxComponent: _ctx.checkboxEvent
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_14, [
              _createElementVNode("span", {
                innerHTML: _ctx.consent.text
              }, null, 8, _hoisted_15),
              (_ctx.consent.linkText)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(['show-hide-details', { open: _ctx.showConsentDetails }]),
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleConsentDetails && _ctx.toggleConsentDetails(...args))),
                    textContent: _toDisplayString((_ctx.showConsentDetails ? 'Skjul ' : 'Vis ') + _ctx.consent.linkText)
                  }, null, 10, _hoisted_16))
                : _createCommentVNode("", true),
              _createVNode(_Transition, { name: "slide-vertical-no-delay" }, {
                default: _withCtx(() => [
                  (_ctx.consent.detailsText && _ctx.showConsentDetails)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        innerHTML: _ctx.consent.detailsText
                      }, null, 8, _hoisted_17))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["preSelect", "visibleError", "onCheckboxComponent"]), [
          [_vShow, 
					_ctx.showAcceptConsent &&
					_ctx.basketModel.contact_information.acceptConsentCpr &&
					_ctx.emailFilled &&
					_ctx.basketModel.contact_information.rki === 'nej' &&
					_ctx.addressFilled &&
					_ctx.skaderOk
				]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ButtonTapComponent, {
      class: _normalizeClass([_ctx.card.buttonStyle, 'mt-3', { 'btn-disabled': !_ctx.isValid }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.nextStep())),
      "data-gtm": _ctx.basketCms.dataGtm,
      "data-gtm-click-text": _ctx.card.routePath
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.card.linkText), 1)
      ]),
      _: 1
    }, 8, ["class", "data-gtm", "data-gtm-click-text"])
  ]))
}